import React, { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
interface SiteLayoutProps {
  children: React.ReactNode;
}
export function SiteLayout({
  children
}: SiteLayoutProps) {
  const {
    pathname
  } = useLocation();

  // Open every page at the top instantly, like a fresh page load — no visible scrolling.
  useLayoutEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' as ScrollBehavior
    });
  }, [pathname]);
  return <div className="flex min-h-screen w-full flex-col bg-ink text-chalk" data-id="element-147" data-mp="3i0mssv8qbd7k">
      <Header data-id="element-148" data-mp="j3nlibwhgwf" />
      <main className="flex-1" data-id="element-149" data-mp="jlt75kgd7h0">{children}</main>
      <Footer data-id="element-150" data-mp="kn2b4hwrjw3" />
    </div>;
}